var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSingleMap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 62,
    viewBox: "0 0 146 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 138,
    height: 52,
    rx: 26,
    fill: "#0078A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 138,
    height: 52,
    rx: 26,
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1477 24.3636V36H51.1705V27.9886H51.2784L54.4943 35.9659H56.0057L59.2216 28.0057H59.3295V36H61.3523V24.3636H58.7727L55.3182 32.7955H55.1818L51.7273 24.3636H49.1477ZM65.7482 36.1761C67.1175 36.1761 67.9357 35.5341 68.3107 34.8011H68.3789V36H70.3561V30.1591C70.3561 27.8523 68.4755 27.1591 66.8107 27.1591C64.9755 27.1591 63.5664 27.9773 63.1118 29.5682L65.0323 29.8409C65.2368 29.2443 65.8164 28.733 66.822 28.733C67.7766 28.733 68.2993 29.2216 68.2993 30.0795V30.1136C68.2993 30.7045 67.68 30.733 66.1402 30.8977C64.447 31.0795 62.8277 31.5852 62.8277 33.5511C62.8277 35.267 64.0834 36.1761 65.7482 36.1761ZM66.2823 34.6648C65.4243 34.6648 64.8107 34.2727 64.8107 33.517C64.8107 32.7273 65.4982 32.3977 66.4186 32.267C66.9584 32.1932 68.038 32.0568 68.305 31.8409V32.8693C68.305 33.8409 67.5209 34.6648 66.2823 34.6648ZM72.1043 39.2727H74.1611V34.625H74.2464C74.5702 35.2614 75.2464 36.1534 76.7464 36.1534C78.8032 36.1534 80.343 34.5227 80.343 31.6477C80.343 28.7386 78.7577 27.1591 76.7407 27.1591C75.2009 27.1591 74.5589 28.0852 74.2464 28.7159H74.127V27.2727H72.1043V39.2727ZM74.1214 31.6364C74.1214 29.9432 74.8486 28.8466 76.1725 28.8466C77.5418 28.8466 78.2464 30.0114 78.2464 31.6364C78.2464 33.2727 77.5305 34.4659 76.1725 34.4659C74.86 34.4659 74.1214 33.3295 74.1214 31.6364ZM87.0808 24.3636H84.7683L88.8649 36H91.4672L95.5694 24.3636H93.2513L90.2285 33.5227H90.1092L87.0808 24.3636ZM96.6912 36H98.748V27.2727H96.6912V36ZM97.7253 26.0341C98.3787 26.0341 98.9128 25.5341 98.9128 24.9205C98.9128 24.3011 98.3787 23.8011 97.7253 23.8011C97.0662 23.8011 96.5321 24.3011 96.5321 24.9205C96.5321 25.5341 97.0662 26.0341 97.7253 26.0341ZM104.407 36.1705C106.441 36.1705 107.839 35.1761 108.202 33.6591L106.282 33.4432C106.003 34.1818 105.321 34.5682 104.435 34.5682C103.106 34.5682 102.225 33.6932 102.208 32.1989H108.287V31.5682C108.287 28.5057 106.446 27.1591 104.299 27.1591C101.799 27.1591 100.168 28.9943 100.168 31.6875C100.168 34.4261 101.776 36.1705 104.407 36.1705ZM102.214 30.8125C102.276 29.6989 103.1 28.7614 104.327 28.7614C105.509 28.7614 106.304 29.625 106.316 30.8125H102.214ZM111.462 36H113.609L115.246 30.1023H115.365L117.001 36H119.144L121.615 27.2727H119.513L118.001 33.375H117.916L116.348 27.2727H114.274L112.706 33.4091H112.626L111.092 27.2727H108.996L111.462 36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7528 23.1854L25.2 25.85C25.0741 25.9444 25 26.0926 25 26.25V36C25 36.412 25.4704 36.6472 25.8 36.4L28.7528 34.1854C28.9043 34.0718 29.107 34.0535 29.2764 34.1382L34.7236 36.8618C34.893 36.9465 35.0957 36.9282 35.2472 36.8146L38.8 34.15C38.9259 34.0556 39 33.9074 39 33.75V24C39 23.588 38.5296 23.3528 38.2 23.6L35.2472 25.8146C35.0957 25.9282 34.893 25.9465 34.7236 25.8618L29.2764 23.1382C29.107 23.0535 28.9043 23.0718 28.7528 23.1854Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 23V34",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 26V37",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 0,
    width: 146,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSingleMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/single-map.3d37440c0ade148f29f47c256fdf0b8e.svg";